"use strict";

export const guestInput = (value, min, max) => ({
    value,
    min,
    max,
    disabledAdd: false,
    disabledSub: false,
    yithBookingInput: jQuery('#yith-wcbk-booking-persons'),
    init() {
        this.checkNeedDisable();
        window.addEventListener('load', () => this.yithBookingInput.val(this.value).trigger('change'), false);
        setTimeout(() => this.dispatch(), 0);
    },
    dispatch() {
        window.dispatchEvent(new CustomEvent('guest-number-change', {
            detail: {
                value: this.value
            }
        }));
    },
    checkNeedDisable() {
        this.disabledSub = this.value <= this.min;
        this.disabledAdd = this.value >= this.max;
        this.dispatch();
    },
    add() {
        if (this.value < this.max) {
            this.value++;
            this.yithBookingInput.val(this.value).trigger('change');
        }
        this.checkNeedDisable();
    },
    sub() {
        if (this.value > this.min) {
            this.value--;
            this.yithBookingInput.val(this.value).trigger('change');
        }
        this.checkNeedDisable();
    }
})